import { render, staticRenderFns } from "./TongJi.vue?vue&type=template&id=8a0395f4&scoped=true"
import script from "./TongJi.vue?vue&type=script&lang=js"
export * from "./TongJi.vue?vue&type=script&lang=js"
import style0 from "./TongJi.vue?vue&type=style&index=0&id=8a0395f4&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "8a0395f4",
  null
  
)

export default component.exports